import _defineProperty from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _classCallCheck from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "/var/jenkins/workspace/Consolidated/Code/Dev/Web@2/platforms/web/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
import { Component } from 'react';
import { TYPEOF } from '../../constants';
import { TooltipTypes } from '../../utils/tooltipConstants';
import utils from '../../utils';
var formatter = require('format-number');
var format = formatter({
  prefix: '',
  suffix: '',
  truncate: 1
});
var CurrencyDisplay = /*#__PURE__*/function (_Component) {
  function CurrencyDisplay() {
    var _this;
    _classCallCheck(this, CurrencyDisplay);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, CurrencyDisplay, [].concat(args));
    _this.state = {
      tooltipType: null
    };
    _this._truncateValue = function (value) {
      var truncationTypes = [{
        value: 0,
        postfix: ''
      }, {
        value: 1000000,
        postfix: 'M'
      }, {
        value: 1000000000,
        postfix: 'B'
      }, {
        value: 1000000000000,
        postfix: 'T'
      }];
      var rval = null;
      truncationTypes.forEach(function (truncationType) {
        if (value >= truncationType.value) {
          rval = truncationType;
        }
      });
      return rval;
    };
    _this._formatValue = function (value) {
      var truncate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
      if (truncate) {
        var truncation = _this._truncateValue(value);
        if (truncation.value > 0) {
          return format(value / truncation.value) + truncation.postfix;
        }
        return format(value);
      }
      return format(value);
    };
    _this._showTooltipMobile = function (type) {
      if (_this.props.tooltipType !== TooltipTypes.COINS || _this.props.tooltipType !== TooltipTypes.LOYALTY) {
        _this.setState({
          tooltipType: type
        });
        _this._setTooltipDetails();
        _this.props.changeTooltipType(type);
        _this.props.shouldShowTooltip(true);
      } else {
        _this.props.changeTooltipType();
        _this.props.shouldShowTooltip(false);
      }
    };
    _this._setTooltipDetails = function () {
      var _tooltipDetails = {
        disableChildren: true,
        title: _this.rawValue,
        source: _this.props.source,
        ibw: _this.props.ibw,
        iconType: _this.props.iconType,
        containerStyle: _objectSpread({
          width: _this.props.containerWidth,
          height: _this.props.containerHeight
        }, _this.props.tooltipPosition),
        tipStyle: _objectSpread({}, _this.props.tipStyle ? _this.props.tipStyle : {}),
        actionHandler: _this.props.onClick
      };
      _this.props.tooltipDetails(_tooltipDetails);
    };
    return _this;
  }
  _inherits(CurrencyDisplay, _Component);
  return _createClass(CurrencyDisplay, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
        value = _this$props.value,
        showTooltip = _this$props.showTooltip,
        tooltipType = _this$props.tooltipType;
      if (prevProps.value !== value && showTooltip && tooltipType === this.state.tooltipType && tooltipType && this.state.tooltipType && !utils.isWebOrMobileWeb()) {
        this._setTooltipDetails();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var displayText = this.props.value;
      this.rawValue = null;
      if (typeof this.props.value === TYPEOF.NUMBER) {
        displayText = this._formatValue(this.props.value);
        this.rawValue = this._formatValue(this.props.value, false);
      }
      var truncated = this.props.value >= 1000000;
      return this.props.render({
        displayText: displayText,
        truncated: truncated,
        rawValue: this.rawValue,
        containerWidth: this.props.containerWidth,
        containerHeight: this.props.containerHeight,
        onClickHandler: this.props.imageOnly || truncated ? this.props.toggleTooltip || this._showTooltipMobile : this.props.enableOnClick ? this.props.onClick : null
      });
    }
  }]);
}(Component);
export { CurrencyDisplay as default };
CurrencyDisplay.defaultProps = {
  containerWidth: 200,
  containerHeight: 60
};